module.exports = __webpack_public_path__ + "img/156.5067fa7d.jpg";